import React from "react";
import ReactPlayer from "react-player";
import NotificationSystem from "react-notification-system";
import moment from "moment";
import {
  Card,
  CardBody,
  CardImg,
  Col,
  Row,
  Button,
  Input,
  Label,
  CardFooter,
  FormGroup,
  Form,
} from "reactstrap";
import * as Server from "../Server";
import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import config from "./../config/local";
import * as GeneralFunctions from "../GeneralFunctions";
let user = {};
class ProductEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedImg: "",
      selectedVideo: "",
      showLoader: false,
      product: props.product || {},
      category: [],
      categoryforSubcategories: [],
    };
    this.updateProduct = this.updateProduct.bind(this);
    this.createProduct = this.createProduct.bind(this);
  }
  formData = new FormData();

  componentDidMount() {
    this.getCategories();
  }
  updateFormData = () => {
    this.formData.append("title", this.state.product.title);
    this.formData.append("subtitle", this.state.product.subtitle);
    this.formData.append("description", this.state.product.description || "");
    this.formData.append("base_price", this.state.product.base_price);
    this.formData.append(
      "discount_price",
      this.state.product.discount_price || 0
    );
    this.formData.append("quantity", this.state.product.quantity);
    this.formData.append(
      "productsFrom",
      this.state.product.productsFrom || "Mall"
    );
    this.formData.append("status", this.state.product.status || "");
    this.formData.append("size", this.state.product.size || "");
    this.formData.append("weight", this.state.product.weight || "");
    this.formData.append("category", this.state.product.category);
    this.formData.append("subCategory", this.state.product.subCategory);
    this.formData.append("barcodeId", this.state.product.barcodeId || "");
    this.formData.append("sellToMerchant", this.state.product.sellToMerchant);
    this.formData.append("expiryDate", this.state.product.expiryDate);
    this.formData.append("zipCode", this.state.product.zipCode || "");
    this.formData.append("condition", this.state.product.condition || "");
    this.formData.append("productImages", this.state.selectedImg || []);
    this.formData.append("productVideos", this.state.selectedVideo || []);
    this.formData.append("appName", user.forApp || "");
  };
  async getCategories() {
    user = GeneralFunctions.getAuthUser();
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: `/open/category/list?forApp=${user.forApp}&categoryFrom=mall`,
        method: "GET",
      });
      if (response) {
        this.setState({
          showLoader: false,
          category: response.categories,
          categoryforSubcategories: response.categories.find(
            (value) => this.state.product.category === value.name
          ),
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  }

  createProduct = async (event) => {
    event.preventDefault();
    this.updateFormData();
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "shop/product/create",
        method: "POST",
        data: this.formData,
      });
      if (response) {
        this.setState({ showLoader: false });
        this.closeEditPage();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateProduct = async (event) => {
    event.preventDefault();
    this.updateFormData();
    this.formData.append("productId", this.state.product._id);
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "shop/product/update",
        method: "POST",
        data: this.formData,
      });
      if (response) {
        this.setState({ showLoader: false });
        this.closeEditPage();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };
  closeEditPage() {
    this.props.closeProductEdit();
  }

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page
          title={this.props.productEditKey}
          breadcrumbs={[{ name: this.props.productEditKey, active: true }]}
        >
          <Row>
            <Col>
              <Card className="mb-3">
                <CardBody>
                  <Form
                    onSubmit={
                      this.props.productEditKey === "Product-Update"
                        ? this.updateProduct
                        : this.createProduct
                    }
                  >
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="title">Title</Label>
                          <Input
                            type="text"
                            name="title"
                            required
                            value={this.state.product.title || ""}
                            placeholder="Title"
                            onChange={(event) => {
                              event.persist();
                              this.setState((prevState) => ({
                                product: {
                                  ...prevState.product,
                                  title: event.target.value,
                                },
                              }));
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="subtitle">Subtitle</Label>
                          <Input
                            type="text"
                            name="subtitle"
                            required
                            placeholder="Subtitle"
                            value={this.state.product.subtitle || ""}
                            onChange={(event) => {
                              event.persist();
                              this.setState((prevState) => ({
                                product: {
                                  ...prevState.product,
                                  subtitle: event.target.value,
                                },
                              }));
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="category">Category</Label>
                          <Input
                            type="select"
                            name="category"
                            value={this.state.product.category}
                            required
                            onChange={(event) => {
                              event.persist();
                              this.setState((prevState) => ({
                                categoryforSubcategories: this.state.category.find(
                                  (value) => event.target.value === value.name
                                ),
                                product: {
                                  ...prevState.product,
                                  category: event.target.value,
                                  subCategory: "",
                                },
                              }));
                            }}
                          >
                            <option value="">Select</option>
                            {(this.state.category || []).map(
                              (category, index) => (
                                <option value={category.name} key={index}>
                                  {category.name}
                                </option>
                              )
                            )}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="subcategory">SubCategory</Label>
                          <Input
                            type="select"
                            name="subcategory"
                            value={this.state.product.subCategory}
                            required
                            onChange={(event) => {
                              event.persist();
                              this.setState((prevState) => ({
                                product: {
                                  ...prevState.product,
                                  subCategory: event.target.value,
                                },
                              }));
                            }}
                          >
                            <option value="">Select</option>
                            {this.state.categoryforSubcategories &&
                              (
                                this.state.categoryforSubcategories
                                  .subCategories || []
                              ).map((Subcategory, index) => (
                                <option value={Subcategory.name} key={index}>
                                  {Subcategory.name}
                                </option>
                              ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="baseprice">BasePrice</Label>
                          <Input
                            type="number"
                            required
                            name="baseprice"
                            placeholder="BasePrice"
                            value={this.state.product.base_price || ""}
                            onChange={(event) => {
                              event.persist();
                              this.setState((prevState) => ({
                                product: {
                                  ...prevState.product,
                                  base_price: event.target.value,
                                },
                              }));
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="discountprice">Discount Price</Label>
                          <Input
                            type="number"
                            name="discountprice"
                            placeholder="Discount Price Upto 100"
                            maxLength="100"
                            value={this.state.product.discount_price || ""}
                            onChange={(event) => {
                              event.persist();
                              if (
                                event.target.value >= 0 &&
                                event.target.value <= 100
                              ) {
                                this.setState((prevState) => ({
                                  product: {
                                    ...prevState.product,
                                    discount_price: event.target.value,
                                  },
                                }));
                              }
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="quantity">Quantity</Label>
                          <Input
                            type="number"
                            required
                            name="quantity"
                            placeholder="Quantity"
                            value={this.state.product.quantity || ""}
                            onChange={(event) => {
                              event.persist();
                              this.setState((prevState) => ({
                                product: {
                                  ...prevState.product,
                                  quantity: event.target.value,
                                },
                              }));
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="productsFrom">Products From</Label>
                          <Input
                            type="text"
                            name="productsFrom"
                            required
                            placeholder="productsFrom"
                            value={this.state.product.productsFrom || "Mall"}
                            onChange={(event) => {
                              event.persist();
                              this.setState((prevState) => ({
                                product: {
                                  ...prevState.product,
                                  productsFrom: event.target.value,
                                },
                              }));
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="description">Description</Label>
                          <Input
                            type="textarea"
                            name="description"
                            placeholder="Description"
                            value={this.state.product.description || ""}
                            onChange={(event) => {
                              event.persist();
                              this.setState((prevState) => ({
                                product: {
                                  ...prevState.product,
                                  description: event.target.value,
                                },
                              }));
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="status">Status</Label>
                          <Input
                            type="text"
                            name="status"
                            placeholder="status"
                            value={this.state.product.status || ""}
                            onChange={(event) => {
                              event.persist();
                              this.setState((prevState) => ({
                                product: {
                                  ...prevState.product,
                                  status: event.target.value,
                                },
                              }));
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="size">Size</Label>
                          <Input
                            type="text"
                            name="size"
                            placeholder="size"
                            value={this.state.product.size || ""}
                            onChange={(event) => {
                              event.persist();
                              this.setState((prevState) => ({
                                product: {
                                  ...prevState.product,
                                  size: event.target.value,
                                },
                              }));
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="weight">Weight</Label>
                          <Input
                            type="text"
                            name="weight"
                            placeholder="weight"
                            value={this.state.product.weight || ""}
                            onChange={(event) => {
                              event.persist();
                              this.setState((prevState) => ({
                                product: {
                                  ...prevState.product,
                                  weight: event.target.value,
                                },
                              }));
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="zipCode">ZipCode</Label>
                          <Input
                            type="text"
                            name="zipCode"
                            placeholder="zipCode"
                            value={this.state.product.zipCode || ""}
                            onChange={(event) => {
                              event.persist();
                              this.setState((prevState) => ({
                                product: {
                                  ...prevState.product,
                                  zipCode: event.target.value,
                                },
                              }));
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="expiryDate">ExpiryDate</Label>
                          <Input
                            type="date"
                            name="expiryDate"
                            required
                            placeholder="expiryDate"
                            defaultValue={
                              moment(
                                new Date(this.state.product.expiryDate)
                              ).format("YYYY-MM-DD") || ""
                            }
                            onChange={(event) => {
                              event.persist();
                              this.setState((prevState) => ({
                                product: {
                                  ...prevState.product,
                                  expiryDate: event.target.value,
                                },
                              }));
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="barcodeId">BarcodeId</Label>
                          <Input
                            type="text"
                            name="barcodeId"
                            placeholder="barcodeId"
                            value={this.state.product.barcodeId || ""}
                            onChange={(event) => {
                              event.persist();
                              this.setState((prevState) => ({
                                product: {
                                  ...prevState.product,
                                  barcodeId: event.target.value,
                                },
                              }));
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="sellToMerchant">SellToMerchant</Label>
                          <Input
                            type="select"
                            name="sellToMerchant"
                            value={String(this.state.product.sellToMerchant)}
                            required
                            placeholder="sellToMerchant"
                            onChange={(event) => {
                              event.persist();
                              this.setState((prevState) => ({
                                product: {
                                  ...prevState.product,
                                  sellToMerchant: event.target.value,
                                },
                              }));
                            }}
                          >
                            <option value="">Select</option>
                            <option value="true">True</option>
                            <option value="false">False</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="condition">Condition</Label>
                          <Input
                            type="text"
                            name="condition"
                            value={this.state.product.condition || ""}
                            placeholder="condition"
                            onChange={(event) => {
                              event.persist();
                              this.setState((prevState) => ({
                                product: {
                                  ...prevState.product,
                                  condition: event.target.value,
                                },
                              }));
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      {this.state.product.images ? (
                        this.state.product.images.length ? (
                          this.state.product.images.map((image, index) => (
                            <Col
                              key={index}
                              sm={4}
                              style={{ display: "flex", marginBottom: "5px" }}
                            >
                              <CardImg
                                key={index}
                                width="100%"
                                src={`${config.imageBaseUrl}/${image}`}
                                alt=""
                              />
                            </Col>
                          ))
                        ) : (
                          <Label sm={4}>No Images</Label>
                        )
                      ) : (
                        ""
                      )}
                    </Row>
                    <Row>
                      <Col>
                        <Label>Add Image</Label>
                        <Input
                          type="file"
                          name="images"
                          accept="image/*"
                          onChange={(event) => {
                            event.persist();
                            this.setState({
                              selectedImg: event.target.files[0],
                            });
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      {this.state.product.videos ? (
                        this.state.product.videos.length ? (
                          this.state.product.videos.map((video, index) => (
                            <Col
                              key={index}
                              sm={12}
                              style={{ display: "flex", marginBottom: "5px" }}
                            >
                              <ReactPlayer
                                width="100%"
                                height="100%"
                                controls={true}
                                url={`${config.videoBaseUrl}/${video}`}
                              />
                            </Col>
                          ))
                        ) : (
                          <Label sm={4}>No Videos</Label>
                        )
                      ) : (
                        ""
                      )}
                      <Col>
                        <Label>Add Video</Label>
                        <Input
                          type="file"
                          name="videos"
                          accept="video/*"
                          onChange={(event) => {
                            event.persist();
                            this.setState({
                              selectedVideo: event.target.files[0],
                            });
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        {this.props.productEditKey === "Product-Create" ? (
                          <Button color="primary" type="submit">
                            Create
                          </Button>
                        ) : (
                          <Button color="primary" type="submit">
                            Update
                          </Button>
                        )}
                      </Col>
                      <Col>
                        <Button
                          color="secondary"
                          onClick={(event) => {
                            this.closeEditPage();
                          }}
                        >
                          Cancel
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
                <CardFooter></CardFooter>
              </Card>
            </Col>
          </Row>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
export default ProductEdit;
